interface IconImageComponentProps {
  src: string;
  width?: number | string;
  height?: number | string;
}

const IconImageComponent = ({
  src,
  width = 30,
  height = 30,
}: IconImageComponentProps) => {
  return <img src={src} width={width} height={height}></img>;
};

export default IconImageComponent;
